<template>
  <div>
    <b-modal
      v-model="modalStatus"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Load Template</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>
      <div class="mb-2"><small>Current Template: {{currentTemplate}}</small></div>
      <dx-select-box
        :search-enabled="true"
        :data-source="allTemplates"
        display-expr="title"
        value-expr="field_001"
        class="mb-4"
        @value-changed="selectedValue"
      />
      <div class="btn-container">
        <v-tooltip top max-width="400" open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <b-button
              variant="secondary"
              class="mt-3 mr-2"
              size="sm"
              @click="defaultTemplate"
              v-bind="attrs"
              v-on="on"
            >Load Default
            </b-button>
          </template>
          <span>Remove all the filters from the list</span>
        </v-tooltip>
        <v-tooltip top max-width="400" open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <b-button
              :disabled="disableBtn"
              variant="secondary"
              class="mt-3 mr-2"
              size="sm"
              @click="deleteTemplate"
              v-bind="attrs"
              v-on="on"
            ><i class="far fa-trash-alt"></i>
            </b-button>
          </template>
          <span>Eliminate saved template</span>
        </v-tooltip>
        <v-tooltip top max-width="400" open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <b-button
              :disabled="disableBtn"
              variant="secondary"
              class="mt-3 mr-2"
              size="sm"
              @click="editTemplate"
              v-bind="attrs"
              v-on="on"
            ><i class="far fa-edit"></i>
            </b-button>
          </template>
          <span>Change saved template name</span>
        </v-tooltip>
        <b-button
          :disabled="disableBtn"
          variant="primary"
          class="mt-3 ok-btn"
          size="sm"
          @click="loadTemplate"
        >Load
        </b-button>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalAlert"
      centered
      size="sm"
      button-size="sm"
      no-close-on-backdrop
      title="Alert"
      @show="resetModal"
      @hidden="resetModal"
      @ok="deleteTemplateNow"
      cancelTitle="No"
      okTitle="Yes"
    >Do you really want to delete the <i>{{templateTitle}}</i> template?
    </b-modal>
    <edit-template ref="editTemplateComponent"/>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import DxSelectBox from 'devextreme-vue/select-box'
  import EditTemplate from '@/components/template/EditTemplate.vue'
  export default {
    name: 'load-template',
    components: {
      DxSelectBox,
      EditTemplate
    },
    props: {
      tableType: Number
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        selectedTemplate: 0,
        templateTitle: '',
        disableBtn: true,
        modalAlert: false,
        editableTemplate: null,
        currentTemplate: 'Default'
      }
    },
    created () {
      this.getTemplates()
    },
    methods: {
      defaultTemplate () {
        this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', false)
        this.currentTemplate = 'Default'
        this.$emit(`set-default-state-${this.tableType}`)
      },
      loadTemplate () {
        if (this.selectedTemplate) {
          const selectedTemplate = this.allTemplates.find(x => x.field_001 === this.selectedTemplate)
          this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', false)
          this.disableBtn = true
          this.currentTemplate = selectedTemplate.title
          this.$emit(`set-state-${this.tableType}`, selectedTemplate.state)
        }
      },
      selectedValue (e) {
        this.selectedTemplate = e.value
        if (this.selectedTemplate) {
          this.disableBtn = false
        }
      },
      deleteTemplate () {
        if (this.selectedTemplate) {
          this.templateTitle = this.allTemplates.find(x => x.field_001 === this.selectedTemplate).title
          this.modalAlert = true
        }
      },
      editTemplate () {
        if (this.selectedTemplate) {
          this.editableTemplate = this.allTemplates.find(x => x.field_001 === this.selectedTemplate)
          this.$store.commit('template/SET_EDIT_TEMPLATE_STATUS', true)
          this.$refs.editTemplateComponent.loadData(this.editableTemplate)
        }
      },
      async deleteTemplateNow () {
        this.modalAlert = false
        try {
          const { errors } = await this.$store.dispatch('template/DELETE_TEMPLATE', {
            formData: this.selectedTemplate
          })
          if (!errors) {
            this.selectedTemplate = 0
            this.getTemplates()
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async getTemplates () {
        try {
          const { errors } = await this.$store.dispatch('template/GET_TEMPLATES', {
            formData: this.tableType
          })
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async updateTemplate () {
        this.modalAlert = false
        const overwriteTemplate = {
          id: this.matchingTemplates[0].field_001,
          state: this.template.state
        }
        try {
          const { errors } = await this.$store.dispatch('template/UPDATE_TEMPLATE', {
            formData: overwriteTemplate
          })
          if (!errors) {
            this.$store.commit('template/SET_SAVE_TEMPLATE_STATUS', false)
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      resetModal () {
        this.modalAlert = false
      },
      closeModal () {
        this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', false)
        this.disableBtn = true
      }
    },
    computed: {
      ...mapGetters({
        allTemplates: 'template/TEMPLATES'
      }),
      ...mapState({
        modalStatus: state => state.template.loadTemplateStatus
      })
    }
  }
</script>
<style lang="scss">
.btn-container {
  display: flex;

  .ok-btn {
    margin-left: auto;
    margin-right: 0;
  }
}
</style>
